










import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';
import { openEdit } from '@/main/router/routerPath';
import { PageModeMixin } from '@/main/mixins/pageMode';
import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';

export default PageModeMixin.extend({
	name: 'ZakazkaPendingItems',
	props: {
		storeUri: { type: String, default: null },
		disabled: { type: Boolean, default: false },
	},
	data() {
		return {
			visibleColumnsForPendingParts: new Set(
				['ZAKAZKA_NR',
					'ND_NR',
					'TEXT',
					'STAV',
					'X_STAVVJ',
					'SEGMENT_BASED_DISC',
					'VIN_BASED_DISC',
					'DISCOUNT_PERCENT',
					'DISCOUNT_VAL',
					'PC_WITHOUT_GST',
					'PC_WITH_GST',
					'HSN_CODE',
					'PC_BEZ_DPH_NAD',
					'PC_VC_DPH_NAD',
					'SHARE',
					'IS_ADDITIONAL',
					'ADDITIONAL_JOB_STATUS',
					'CESS',
					'PC_PERCENTAGE',
					'DEALER_NAME',
					'DEALER_NUMBER',
					'UZAVRENI_DAT',
				],
			),
			visibleColumnsForPendinglabors: new Set(
				[
					'ZAKAZKA_NR',
					'TEXT',
					'CAS_JDN_POC_CELK',
					'LAK_JDN_POC_2BLANKA',
					'DISCOUNT_PERCENT',
					'DISCOUNT_VAL',
					'PC_WITHOUT_GST',
					'PC_WITH_GST',
					'PC_BEZ_DPH_NAD',
					'SEGMENT_BASED_DISC',
					'VIN_BASED_DISC',
					'PC_PP_SL_PO',
					'PC_LAK_SL_PO',
					'PC_VC_DPH_NAD',
					'PC_PP_SL_PO',
					'PC_LAK_SL_PO',
					'OSOBNI_CIS_PRIJ',
					'ELSA_STATUS',
					'NASOB_ORIG_PRP',
					'SHARE',
					'CUSTOMER',
					'INSURANCE',
					'SERVICE_PACKAGE_ID',
					'IS_ADDITIONAL',
					'ADDITIONAL_JOB_STATUS',
					'PC_IGST',
					'PC_SGST',
					'PC_CGST',
					'PC_UTGST',
					'PC_PERCENTAGE',
					'CESS',
					'VALUE',
					'PERCENTAGE',
					'DEALER_NAME',
					'DEALER_NUMBER',
					'UZAVRENI_DAT',
				],
			),
		};
	},
	computed: {
		...genVuexComputeds(store),
		pendingParts(): any {
			const copy = _.cloneDeep(this.dependentTables.ZakazkaNdPending);
			_.map(copy.columns, (col) => {
				col.isVisible = this.visibleColumnsForPendingParts.has(col.columnName);
			});
			return copy;
		},
		pendingLabor(): any {
			const copy = _.cloneDeep(this.dependentTables.ZakazkaPracovniPozicePending);
			_.map(copy.columns, (col) => {
				col.isVisible = this.visibleColumnsForPendinglabors.has(col.columnName);
			});
			return copy;
		},
	},
	methods: {
		viewZakazkaNd(event: any) {
			openEdit('ZakazkaNd', PageMode.VIEW, { props: true, id: event.data.ID });
		},
		viewZakazkaPP(event: any) {
			openEdit('ZakazkaPracovniPozice', PageMode.VIEW, { props: true, id: event.data.ID });
		},
		editClick() {
			this.showErrorAlert({ message: 'NonEditableItem' });
			return false;
		},
	},
});
